import type { InjectionKey } from 'vue'
import type { FormRules as ElFormRules, FormItemRule as ElFormItemRule } from 'element-plus'

type Arrayable<T> = T | T[]

export type FormRules = ElFormRules
export type FormItemRule = ElFormItemRule

export interface FormProps {
  rules?: FormRules
  itemSpan?: number
  itemLabelWidth?: string | number
  disabled?: boolean
  modelValue: Record<string, any>
}

export interface FormExpose {
  validate: () => Promise<boolean>
}

export interface FormContext {
  modelValue: Record<string, any>
  updateModelValue: (name: string, value: any) => void
  updateModelValueMulti: (data: Record<string, any>) => void
  rules?: FormRules
  itemSpan: number
  disabled?: boolean
}

export const formContextKey: InjectionKey<FormContext> = Symbol('formContextKey')

export interface FormItemProps {
  name: string
  label?: string
  span?: number
  labelWidth?: string | number
  required?: boolean
  rules?: Arrayable<FormItemRule>
}
